import { cn } from '../../lib/utils';

/**
 * Pine Group 공통 배지 컴포넌트
 *
 * variant: 'default' | 'blue' | 'green' | 'red' | 'yellow' | 'gray' | 'navy'
 */
const variants = {
  default: 'bg-[var(--bg-subtle)] text-[var(--text-sub)]',
  blue:    'bg-accent-100 text-accent-700 dark:bg-pine-700 dark:text-accent-300',
  green:   'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
  red:     'bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-400',
  yellow:  'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  gray:    'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
  navy:    'bg-pine-900 text-white dark:bg-pine-700',
};

export function Badge({ variant = 'default', className, children, ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-none',
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
